<template>
    <b-button class="mb-5" variant="primary-user" @click="add">Add Shipping rule</b-button>
</template>

<script>
    export default {
        name: 'AddShippingRule',
        data() {
            return {
            }
        },
        methods: {
            add() {
                this.$emit('addShippingRule')
                this.$root.$emit('bv::show::modal', 'shipping-settings')
            }
        }
    }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/ShippingPolicySettings/components/AddRule.vue